import { cva } from "cva";

export const headerStyles = cva({
  base: "w-full shadow-md-transparent sticky top-0 relative z-100 transition-colors duration-250 ease-out-quad",
  variants: {
    menuOpen: {
      true: "max-md:bg-surface",
      false: "",
    },
  },
});

export const headerContainerStyles = cva({
  base: "mds-container flex items-center justify-between gap-x-16 h-64",
});
